const envOrigin1 = {
  VITE_APP_URL: import.meta.env.VITE_APP_URL,
  VITE_APP_CDNURL: import.meta.env.VITE_APP_CDNURL,
  VITE_APP_QNURL: import.meta.env.VITE_APP_QNURL,
};

// 多域名判断
const switchOrigin = () => {
  if (import.meta.env.VITE_APP_MODE === 'production') {
    if (window.location.origin === import.meta.env.VITE_APP_CDNURL) {
      return envOrigin1;
    }
  } else {
    return envOrigin1;
  }
};
const useOrigin = switchOrigin();
export default useOrigin;
